import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <div className="footer">
      <div className="copyright">
        <p>Copyright © VAS Oatek {year}</p>
      </div>
    </div>
  );
}
